import { render, staticRenderFns } from "./safetyManagement.vue?vue&type=template&id=a49bc856&scoped=true"
import script from "./safetyManagement.vue?vue&type=script&lang=js"
export * from "./safetyManagement.vue?vue&type=script&lang=js"
import style0 from "./safetyManagement.vue?vue&type=style&index=0&id=a49bc856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49bc856",
  null
  
)

export default component.exports